import { render, staticRenderFns } from "./NewPartListModal.vue?vue&type=template&id=622b3032"
import script from "./NewPartListModal.vue?vue&type=script&lang=js"
export * from "./NewPartListModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports